import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, IconButton, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import PanelShell from './PanelShell';

const SwitchPanel = ({ nodeType, nodeId, data, onChange }) => {
  const [cases, setCases] = useState(data?.cases || [{ value: 'Case 1' }, { value: 'Case 2' }]);

  useEffect(() => {
    setCases(data?.cases && data.cases.length ? data.cases : [{ value: 'Case 1' }, { value: 'Case 2' }]);
  }, [data]);

  if (nodeType !== 'Switch') return null;

  const updateCase = (i, v) => {
    const next = cases.slice();
    next[i] = { value: v };
    setCases(next);
  };
  const addCase = () => setCases((c) => [...c, { value: `Case ${c.length + 1}` }]);
  const removeCase = (i) => setCases((c) => c.filter((_, idx) => idx !== i));

  const save = () => {
    const Title = `Switch (${cases.map(c => c.value).join(', ')})`;
    onChange({ label: 'Switch', cases, Title });
  };

  return (
    <PanelShell
      title="Switch"
      onSave={save}
      actions={
        <Button
          startIcon={<AddIcon />}
          onClick={addCase}
          size="small"
        >
          Case Ekle
        </Button>
      }
    >
      <Grid container spacing={2}>
        {cases.map((c, i) => (
          <Grid item xs={12} key={i}>
            <Box display="flex" gap={1} alignItems="center">
              <TextField
                fullWidth
                size="small"
                value={c.value}
                onChange={(e) => updateCase(i, e.target.value)}
                label={`Case ${i + 1}`}
              />
              <IconButton
                onClick={() => removeCase(i)}
                color="error"
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </Grid>
        ))}
      </Grid>
    </PanelShell>
  );
};

export default SwitchPanel;
